import { rest } from 'msw';
import SchoolDistrictData from '../fixtures/input.json';
const {
    schools,
    educators,
    terms,
    classes,
    students,
    linkingStudies,
    linkingStudiesWithCutScores,
} = SchoolDistrictData;

export default [
    rest.get('/partnerConfig/partners/:partnerBid/terms', (req, res, ctx) => {
        console.log('------- TERMS MSW INTERCEPT ------- ', req.params);

        // // the partnerBid path parameter is used here to select the set of terms.  I did not follow
        // //    this pattern for most of the other endpoints due to this being a spike, but I would
        // //    suggest extending this to the other mocked endpoints.
        // const { partnerBid } = req.params;
        // const terms = partnerTerms[partnerBid];
        // if (terms == null) {
        //     throw new Error(`could not find terms for ${partnerBid}`);
        // }

        return res(ctx.status(200), ctx.json({ terms }));
    }),
    rest.get('/gateway/api/studies', (req, res, ctx) => {
        console.log('------- STUDIES MSW INTERCEPT ------- ', req.params);

        return res(ctx.status(200), ctx.json(linkingStudies));
    }),
    rest.post('/gateway/api/linking-studies', async (req, res, ctx) => {
        console.log('------- STUDIES MSW INTERCEPT ------- ', req.params);
        const body = await req.json();
        if (!Array.isArray(body)) {
            return res(ctx.status(400), ctx.json({ message: 'body must be an array' }));
        }
        const response = body.map((study) => {
            const linkingStudy = linkingStudiesWithCutScores.find((ls) => {
                return ls.study === study.study && ls.seasonNumber === study.season;
            });
            const cutScores = linkingStudy?.cutScores || [];
            return {
                ...study,
                cutScores,
            };
        });
        return res(ctx.status(200), ctx.json(response));
    }),
    rest.get('/reporting-api/v3/reporting-api/partners/:partnerBid/schools/:schoolBid/instructors', (req, res, ctx) => {
        console.log('------- INSTRUCTORS MSW INTERCEPT ------- ', req.params);
        const teachersForSchool = educators[req.params.schoolBid] || [];

        return res(ctx.status(200), ctx.json(teachersForSchool));
    }),
    rest.get('/reporting-api/v3/reporting-api/partners/:partnerBid/schools', (req, res, ctx) => {
        console.log('------- SCHOOLS MSW INTERCEPT ------- ', req.params);

        return res(ctx.status(200), ctx.json(schools));
    }),
    rest.get('/reporting-api/v3/reporting-api/partners/:partnerBid/schools/:schoolBid/classes', (req, res, ctx) => {
        console.log('------- CLASSES MSW INTERCEPT ------- ', req.params);
        const educatorBid = req.url.searchParams.get('educator');
        const schoolBid = req.params.schoolBid;
        const classesToReturn = classes[schoolBid][educatorBid] || [];

        return res(ctx.status(200), ctx.json(classesToReturn));
    }),
    rest.get(
        '/reporting-api/v3/reporting-api/partners/:partnerBid/schools/:schoolBid/classes/:classBid/students',
        (req, res, ctx) => {
            console.log('------- STUDENTS MSW INTERCEPT ------- ', req.params);

            const { classBid } = req.params;
            const studentsForClass = students[classBid] || [];
            return res(ctx.status(200), ctx.json(studentsForClass));
        }
    ),
];
